<div class="content-banner d-flex">
    <div class="content-banner-information">
        <label-block [info]="BanerFirstTab"></label-block>
    </div>
    <img class="img-banner" src="../../../../assets/images/imagen_factura.jpg" alt="img-documento" />
</div>
<div class="content-banner-information">
    <ul>
        <label-block [info]="documento"></label-block>
    </ul>
</div>
<div class="d-block justify-content-center">
    <form [formGroup]="facturaForm" class="contact-form justify-content-center" *ngIf="facturaForm">
        <div class="contact-column">
            <div class="contact-column row">
                <div class="col-md-4"></div>
                <div class="col-md-4 col-sm-12">
                    <label for="placa" required>Peaje *</label><br>
                    <div class="btn-group-responsive mt-2 mb-4" role="group"
                        aria-label="Basic radio toggle button group">
                        <input type="radio" class="btn-check" value="peaje_neiva" name="origen" id="btnradio1"
                            autocomplete="off" checked formControlName="origen">
                        <label class="btn btn-outline-primary" for="btnradio1">Neiva</label>

                        <input type="radio" class="btn-check" value="peaje_pata" name="origen" id="btnradio2"
                            autocomplete="off" formControlName="origen">
                        <label class="btn btn-outline-primary" for="btnradio2">Pata</label>

                        <input type="radio" class="btn-check" value="peaje_flandes" name="origen" id="btnradio3"
                            autocomplete="off" formControlName="origen">
                        <label class="btn btn-outline-primary" for="btnradio3">Flandes</label>
                    </div>
                </div>
            </div>

            <div class="contact-column row mt-2">
                <div class="col-md-4"></div>
                <div class="col-md-4 col-sm-12">
                    <label for="placa" required>Placa</label><br>
                    <input type="text" id="placa" formControlName="placa" placeholder="Digite su placa" maxlength="10"
                        class="form-control" />
                    <div class="error-msn"
                        [class.error-show]="facturaForm.controls['placa'].invalid && this.facturaForm.controls['placa'].touched">
                        El campo placa no es válido
                    </div>
                </div>
            </div>
            <div class="contact-column row mt-2">
                <div class="col-md-4"></div>
                <div class="col-md-4 col-sm-12">
                    <label for="noTiquete" required>Número tiquete</label><br>
                    <input type="text" id="noTiquete" formControlName="noTiquete" placeholder="Digite su tiquete"
                        class="form-control" />
                    <div class="error-msn"
                        [class.error-show]="facturaForm.controls['noTiquete'].invalid && this.facturaForm.controls['noTiquete'].touched">
                        El campo número de tiquete no es válido
                    </div>
                </div>
            </div>

            <div class="contact-column row">
                <div class="col-md-4"></div>
                <div class="col-md-4 col-sm-12">
                    <label for="fechaCreacion" required>Fecha *</label><br>
                    <input type="date" id="fechaCreacion" formControlName="fechaCreacion" class="form-control" />
                    <div class="error-msn"
                        [class.error-show]="facturaForm.controls['fechaCreacion'].hasError('required') && this.facturaForm.controls['fechaCreacion'].touched">
                        La fecha es requerida
                    </div>
                </div>
            </div>
            <div class="contact-column row mt-3" style="justify-content: center; text-align: center;">
                <button type="submit" class="btn btn-primary" (click)="getInvoice()">Consultar</button>
            </div>
        </div>
    </form>
    <div class="container mt-4" *ngIf="showAlert">
        <div class="contact-column row">
            <div class="col-md-4 col-sm-12"></div>
            <div class="col-md-4 col-sm-12">
                <div class="alert alert-danger" role="alert">
                    Digite una placa y/o número de tiquetes validos
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-4" *ngIf="showAlertInfo">
        <div class="contact-column row">
            <div class="col-md-4 col-sm-12"></div>
            <div class="col-md-4 col-sm-12">
                <div class="alert alert-info" role="alert">
                    Sin resultados encontrados
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-4" *ngIf="showAlertError">
        <div class="contact-column row">
            <div class="col-md-4 col-sm-12"></div>
            <div class="col-md-4 col-sm-12">
                <div class="alert alert-danger" role="alert">
                    Error obteniendo facturas, intente más tarde
                </div>
            </div>
        </div>
    </div>

    <div class="loader" *ngIf="loadingServiceFactura">
        <mat-spinner></mat-spinner>
    </div>
    <div class="contact-column row p-3 mt-4" style="justify-content: center;" *ngIf="facturas.length > 0">
        <div class="card" style="width: 90vw;">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col">N° Tiquete</th>
                                <th scope="col">Placa</th>
                                <th scope="col">fecha</th>
                                <th scope="col">Importe</th>
                                <th scope="col">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let factura of facturas">
                                <td>
                                    <p>{{ factura.noTiquete }}</p>
                                </td>
                                <td>{{ factura.placa | uppercase }}</td>
                                <td>{{ (factura.fechaRecaudo + 'T' + factura.horaRecaudo) | date:'dd/MM/yyyy HH:mm' }}
                                </td>
                                <td>{{ factura.importe | currency:'$ ':'symbol':'1.0' }}</td>
                                <td><a [href]="factura.envios[0]?.responseBody?.UrlPdf" target="_blank"
                                        class="underline-hover" style="color: #241ef2;">Descargar</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="container" *ngIf="facturas.length > 0">
        <nav aria-label="Page navigation example" *ngIf="!ocultarPaginado">
            <ul class="pagination">
                <li class="page-item">
                    <button class="page-link" (click)="actualizarEstadoPagina(['1p'])" aria-label="Previous">
                        <span aria-hidden="true">««</span>
                    </button>
                </li>
                <li class="page-item">
                    <button class="page-link" (click)="actualizarEstadoPagina(['pa'])" aria-label="Previous">
                        <span aria-hidden="true">«</span>
                    </button>
                </li>
                <li *ngIf="rangoPaginasArray[0]+1" [ngClass]="{'active': arrayPaginadoResaltar[2]}" class="page-item">
                    <button class="page-link"
                        (click)="actualizarEstadoPagina([rangoPaginasArray[0]])">{{rangoPaginasArray[0] + 1}}</button>
                </li>
                <li *ngIf="rangoPaginasArray[1]+1" [ngClass]="{'active': arrayPaginadoResaltar[3]}" class="page-item">
                    <button class="page-link"
                        (click)="actualizarEstadoPagina([rangoPaginasArray[1]])">{{rangoPaginasArray[1] + 1}}</button>
                </li>
                <li *ngIf="rangoPaginasArray[2]+1" [ngClass]="{'active': arrayPaginadoResaltar[4]}" class="page-item">
                    <button class="page-link"
                        (click)="actualizarEstadoPagina([rangoPaginasArray[2]])">{{rangoPaginasArray[2] + 1}}</button>
                </li>
                <li *ngIf="rangoPaginasArray[3]+1" [ngClass]="{'active': arrayPaginadoResaltar[5]}" class="page-item">
                    <button class="page-link"
                        (click)="actualizarEstadoPagina([rangoPaginasArray[3]])">{{rangoPaginasArray[3] + 1}}</button>
                </li>
                <li *ngIf="rangoPaginasArray[4]+1" [ngClass]="{'active': arrayPaginadoResaltar[6]}" class="page-item">
                    <button class="page-link"
                        (click)="actualizarEstadoPagina([rangoPaginasArray[4]])">{{rangoPaginasArray[4] + 1}}</button>
                </li>
                <li class="page-item">
                    <button class="page-link" (click)="actualizarEstadoPagina(['ps'])" aria-label="Next">
                        <span aria-hidden="true">»</span>
                    </button>
                </li>
                <li class="page-item">
                    <button class="page-link" (click)="actualizarEstadoPagina(['up'])" aria-label="Next">
                        <span aria-hidden="true">»»</span>
                    </button>
                </li>
            </ul>
        </nav>
        <div class="col-md-4">Página {{paginaActual + 1}} de {{totalPaginas + 1}} </div>
    </div>

</div>